import { mapGetters } from "vuex";
import {
  toLocaleCurrency,
  toLocaleDecimal,
  toLocaleInteger,
} from "@/utils/strings";
import { getInputType } from "@/utils/forms";
import { canVerb, canModule } from "@/utils/permissions";
export default {
  data: () => ({
    allFields: [],
    actions: [], // used to determine which action buttons display in Actions table cell
    actPos: "first", // actions position (default is first): set it to "last" in table's data to change position
  }),
  methods: {
    // Bottoni da 21px, su una riga fino a 3 (a 2px l'uno dall'altro) e da 4
    // in su su due righe (a 4px) (_tables.scss), più il padding della cella
    // (4px + 8px). Con le righe calibrateRows() ricalcola le colonne e
    // fitActionsColumn() la larghezza;
    // min-width tiene la colonna larga anche a tabella vuota.
    // extraActionButtons: bottoni sempre presenti che non stanno in actions.
    actionsThStyle() {
      const buttons = this.actions.length + (this.extraActionButtons || 0);
      const cols = Math.max(1, buttons <= 3 ? buttons : Math.ceil(buttons / 2));
      const gap = buttons <= 3 ? 2 : 4;
      const width = `${21 * cols + gap * (cols - 1) + 12}px`;
      return { width, minWidth: width };
    },
    convertFromCustomAttributesToFields(array) {
      let ret = [];
      if (!array) return ret;
      array.forEach((element) => {
        // console.log("Element: ", element.key, element);
        if (element.is_customizable && element.is_customizable === "N") return;
        // if (element.last_delete) return;
        if (element.is_hidden && element.is_hidden === "Y") return;
        let e = {
          // key: element.key, // REVIEW: here check if key should be: `attributables.${element.key}`
          key: `attributables.${element.key}`,
          label: element.text,
          sortable: element.is_sortable === "Y" ? true : false,
          thClass: "align-middle", // vertically center th label
          formatter: null,
        };
        // REVIEW sarebbe bello se un campo custom relativo ad una valuta, venisse indicato come type="currency"
        //  e non type="text", in questo modo nel mondo perfetto sarebbe possibile applicare
        // la formattazione -> formatter: (value) => toLocaleCurrency(value),
        // sarebbe ancor più bello se il codice qui sotto facesse quello che ci si aspetterebbe, cioè applicare
        // la formattazione al valore del campo custom :-((
        // if (element.type === "text") {
        //   e["formatter"] = (value) => toLocaleCurrency(value);
        //   // e["formatter"] = function(value) {
        //   //   return toLocaleCurrency(value);
        //   // };
        // }
        let fn = null;
        switch (getInputType(element)) {
          // case "text":
          //   fn = (value) => toLocaleCurrency(value);
          //   break;
          case "currency":
            fn = (value) => toLocaleCurrency(value);
            break;
          case "number":
            fn = (value) => toLocaleInteger(value);
            break;
          case "decimal":
            fn = (value) => toLocaleDecimal(value);
            break;
          case "radio":
            fn = (value) => (value === "Y" ? "SI" : "NO");
        }
        if (fn) {
          e.formatter = fn;
        }
        // if (element.is_sortable === "Y") {
        if (e.sortable) {
          e["sortKey"] = `byAttribute.${element.key}`;
        }
        ret.push(e);
      });
      return ret;
    },
    ...mapGetters("auth", ["customAttributes"]),
  },
  // computed: {
  //   ...mapGetters("auth", ["permissions"]),
  // },
  mounted() {},
  beforeMount() {
    // console.debug(`beforeMount: repository = ${this.repository}`);
    // console.debug(`beforeMount: resource = ${this.resource}`);
    // console.debug(
    //   "beforeMount: this.permissions.includes(`resources.${this.resource}.edit`):",
    //   this.permissions.includes(`resources.${this.resource}.edit`)
    // );
    // if (!this.repository) {
    //   console.info("CustomFieldsAndActionsMixin: missing resource");
    // }

    if (
      this.onlyActions.includes("edit") &&
      canVerb(this.resource, "update")
      // this.permissions.includes(`resources.${this.resource}.edit`)
    ) {
      this.actions.push("edit");
    }

    if (
      this.onlyActions.includes("edit_broker") &&
      canVerb(this.resource, "update")
    ) {
      this.actions.push("edit_broker");
    }

    // edit_schedule (modifica/annullamento della schedulazione di invio)
    if (
      this.onlyActions.includes("edit_schedule") &&
      canVerb(this.resource, "update")
    ) {
      this.actions.push("edit_schedule");
    }

    // retry_failed (ritrasmissione dei messaggi falliti di una procedura)
    if (
      this.onlyActions.includes("retry_failed") &&
      canVerb(this.resource, "update")
    ) {
      this.actions.push("retry_failed");
    }

    // view_logs (log LisaComunica della procedura): stesso permesso della voce di menu Log
    if (this.onlyActions.includes("view_logs") && canModule("module.COM")) {
      this.actions.push("view_logs");
    }

    if (
      this.onlyActions.includes("details") &&
      canVerb(this.resource, "show")
      // this.permissions.includes(`resources.${this.resource}.show`)
    ) {
      this.actions.push("details");
    }

    if (
      this.onlyActions.includes("infomodal") &&
      canVerb(this.resource, "show")
      // this.permissions.includes(`resources.${this.resource}.show`)
    ) {
      this.actions.push("infomodal");
    }

    // destroy
    if (
      this.onlyActions.includes("destroy") &&
      canVerb(this.resource, "destroy")
      // this.permissions.includes(`resources.${this.resource}.destroy`)
    ) {
      this.actions.push("destroy");
    }

    // destroy_manual — stessa permission di destroy
    if (
      this.onlyActions.includes("destroy_manual") &&
      canVerb(this.resource, "destroy")
    ) {
      this.actions.push("destroy_manual");
    }

    // detach (pivot_destroy) — stessa permission di destroy
    if (
        this.onlyActions.includes("detach") &&
        canVerb(this.resource, "destroy")
    ) {
      this.actions.push("detach");
    }

    // lisa_for_apps
    if (
      this.onlyActions.includes("lisa_for_apps") &&
      canModule("module.HOME.LAPP") &&
      canVerb("lisa_for_apps", "index")
    ) {
      this.actions.push("lisa_for_apps");
    }

    // lisapay
    if (this.onlyActions.includes("lisapay_register_to_company")) {
      this.actions.push("lisapay_register_to_company");
    }

    // registries - groups
    if (this.onlyActions.includes("custominfogroup")) {
      this.actions.push("custominfogroup");
    }

    // reports
    if (this.onlyActions.includes("reports") && canVerb("reports", "edit")) {
      this.actions.push("reports");
    }

    if (!this.repository) {
      // console.info("CustomFieldsAndActionsMixin: missing repository");
      return;
    }
    // transform custom field (remove unuseful properties like is_*)
    let customAttributes = this.convertFromCustomAttributesToFields(
      this.customAttributes()(this.repository)
    );

    // apply thClass: 'align-middle' to all fields
    // let fields = this.fields.map((obj) => ({
    //   ...obj,
    //   thClass: "align-middle", // vertically center th label
    // }));
    for (let field of this.fields) {
      field.thClass = "align-middle"; // vertically center th label
    }
    for (let field of this.fields.concat(customAttributes)) {
      // L'etichetta può essere tagliata a 2 righe (_tables.scss): il testo
      // intero resta nel title.
      if (!field.headerTitle && typeof field.label === "string") {
        field.headerTitle = field.label;
      }
      // Il contraente spesso porta anche l'indirizzo: un minimo di larghezza
      // perché stia quasi sempre nelle 5 righe delle celle (_tables.scss);
      // oltre, il testo intero è nel title.
      if (field.label === "Contraente") {
        field.thStyle = { ...field.thStyle, minWidth: "160px" };
      }
    }

    if (!this.noCustom) {
      // append custom fields to static fields
      this.allFields = this.fields.concat(customAttributes);
    } else {
      // static fields only
      this.allFields = this.fields;
    }

    if (this.actions.length) {
      switch (this.actPos) {
        // case "first":

        // break;
        case "last":
          this.allFields.push({
            key: "actions",
            stickyColumn: true,
            label: "",
            // thClass: "w-25",
            thStyle: this.actionsThStyle(),
            thClass: "align-middle actions-head", // vertically center th label
            // tdClass: "transparent", // when using rowClass to highlight a row ef in orange, or background would be white.
            // SIDE EFFECT: text scrolls behind
            tdClass: "actions", // when using rowClass to highlight a row ef in orange, or background would be white
          });
          break;
        default:
          this.allFields.unshift({
            key: "actions",
            stickyColumn: true,
            label: "",
            // thClass: "w-25",
            thStyle: this.actionsThStyle(),
            thClass: "align-middle actions-head", // vertically center th label
            // tdClass: "transparent", // when using rowClass to highlight a row ef in orange, or background would be white.
            // SIDE EFFECT: text scrolls behind
            tdClass: "actions", // when using rowClass to highlight a row ef in orange, or background would be white
          });
          // La colonna di selezione (checkbox) sta prima delle azioni.
          {
            const sel = this.allFields.findIndex((f) =>
              ["selezionato", "check"].includes(f.key),
            );
            if (sel > 0) this.allFields.unshift(...this.allFields.splice(sel, 1));
          }
      }
    } else {
      this.allFields.unshift({
        key: "actions",
        stickyColumn: true,
        label: "",
        thStyle: {
          width: `${20 * this.actions.length}px`,
        },
        thClass: "align-middle actions-head",
        tdClass: "actions",
      });
    }
  },
};
